// Single source of truth for the 6 ebook library volumes.
// Used by:
//   - /library index page
//   - <MoreEbooksStrip> cross-sell at the bottom of every landing
//   - any future "ebook picker" surfaces
//
// Each entry is the lightest possible config — just enough to render a card
// and link to the full landing. Detailed config lives in each landing file.

export const EBOOK_CATALOG = [
  {
    slug: "motivated-seller-30-day",
    title: "The 30-Day Motivated Seller Playbook",
    tagline: "Find, score, and lock up your first deal in 30 days — $0 data budget. FLAGSHIP.",
    pageCount: 28,
    category: "Flagship · Cold Start",
    accent: "primary",
    landingPath: "/motivated-seller",
    shortPath: "/motivated-seller",
    featured: true,
  },
  {
    slug: "wealth-blueprint",
    title: "The Real Estate Investor's Wealth Blueprint",
    tagline: "The family-office playbook for wholesalers, rehabbers, and investors who want to build more than a portfolio — a legacy enterprise.",
    pageCount: 76,
    category: "Legacy",
    accent: "primary",
    landingPath: "/wealth-blueprint",
    shortPath: "/blueprint",
    featured: true,
  },
  {
    slug: "cash-buyer-blackbook",
    title: "The Cash Buyer Black Book",
    tagline: "Build, vet, rank, and retain 30-50 verified cash buyers.",
    pageCount: 21,
    category: "Buyer-Side",
    accent: "primary",
    landingPath: "/cash-buyer-blackbook",
    shortPath: "/blackbook",
    featured: true,
  },
  {
    slug: "getting-started",
    title: "Getting Started with iSpeedToClose",
    tagline: "From first lead to first close — every module explained.",
    pageCount: 28,
    category: "Onboarding",
    accent: "primary",
    landingPath: "/getting-started",
    shortPath: "/start",
    featured: true,
  },
  {
    slug: "w2-to-10k",
    title: "From W-2 to $10K Months",
    tagline: "The unromantic, week-by-week 90-day plan to replace your day-job income.",
    pageCount: 24,
    category: "Transformation",
    accent: "primary",
    landingPath: "/from-w2-to-10k",
    shortPath: "/quit-w2",
    featured: true,
  },
  {
    slug: "founder-restart",
    title: "What I'd Do If I Started Over Tomorrow",
    tagline: "Tracy's first-person essay on the playbook he'd actually run today.",
    pageCount: 18,
    category: "Founder Voice",
    accent: "primary",
    landingPath: "/founder-restart",
    shortPath: "/restart",
  },
  {
    slug: "call-coach",
    title: "The 60-Second Seller Call",
    tagline: "The Call Coach scoring rubric with two annotated transcripts.",
    pageCount: 25,
    category: "Sales Craft",
    accent: "primary",
    landingPath: "/free-ebook",
    shortPath: "/ebook",
  },
  {
    slug: "tcpa-guide",
    title: "The TCPA Survival Guide",
    tagline: "Stay compliant on SMS, voice, and DNC — 14-page essentials.",
    pageCount: 14,
    category: "Compliance",
    accent: "primary",
    landingPath: "/tcpa-guide",
    shortPath: "/tcpa-guide",
  },
  {
    slug: "apex-getting-started",
    title: "Getting Started with Apex 2.0",
    tagline: "Step-by-step beginner's guide to the AI voice agent — setup, transcripts, dormancy sweep, safety rails.",
    pageCount: 24,
    category: "Onboarding",
    accent: "primary",
    landingPath: "/v3/learn/library",
    shortPath: "/apex-guide",
  },
  {
    slug: "wholesaling-101",
    title: "Wholesaling 101",
    tagline: "From day one to your first check — the real playbook new wholesalers actually need.",
    pageCount: 30,
    category: "Onboarding",
    accent: "primary",
    landingPath: "/wholesaling-101",
    shortPath: "/wholesaling-101",
  },
  {
    slug: "marketing-machine",
    title: "The Wholesaler's Marketing Machine",
    tagline: "Seven lead-gen channels ranked by cost, speed, and quality — plus the 90-day ramp plan.",
    pageCount: 28,
    category: "Marketing",
    accent: "primary",
    landingPath: "/marketing-machine",
    shortPath: "/marketing-machine",
  },
  {
    slug: "cold-call-script-book",
    title: "The Cold Call Script Book",
    tagline: "40 seller-call scripts by lead source, plus every objection response and voicemail template.",
    pageCount: 40,
    category: "Sales Craft",
    accent: "primary",
    landingPath: "/cold-call-scripts",
    shortPath: "/cold-call-scripts",
  },
  {
    slug: "seller-objections-playbook",
    title: "The 25 Seller Objections Playbook",
    tagline: "The 25 objections you hear most on seller calls — with 3 response scripts and the psychology of each.",
    pageCount: 25,
    category: "Sales Craft",
    accent: "primary",
    landingPath: "/seller-objections",
    shortPath: "/seller-objections",
  },
  {
    slug: "after-first-check",
    title: "After the First Check",
    tagline: "The honest playbook for taxes, LLC, banking, and the 90-day plan after your first assignment fee.",
    pageCount: 24,
    category: "Transformation",
    accent: "primary",
    landingPath: "/after-first-check",
    shortPath: "/first-check",
  },
  {
    slug: "hands-off-wholesaler",
    title: "The Hands-Off Wholesaler",
    tagline: "Hire, train, and trust your first VA — 15 chapters written the way I'd teach it to my own son at the kitchen table.",
    pageCount: 36,
    category: "Team & Ops",
    accent: "primary",
    landingPath: "/hands-off-wholesaler",
    shortPath: "/hands-off",
  },
  {
    slug: "virtual-wholesaler",
    title: "The Virtual Wholesaler",
    tagline: "How to run profitable wholesale deals in markets you've never physically visited — the exact playbook I use to run nationwide from Pennsylvania.",
    pageCount: 36,
    category: "Scale",
    accent: "primary",
    landingPath: "/virtual-wholesaler",
    shortPath: "/virtual",
  },
];
